import { render, staticRenderFns } from "./CancelationPolicySystemList.vue?vue&type=template&id=7ef60d22&scoped=true&"
import script from "./CancelationPolicySystemList.vue?vue&type=script&lang=js&"
export * from "./CancelationPolicySystemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef60d22",
  null
  
)

export default component.exports